import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import { Icon, Dropdown, Button, Menu, MenuItem } from 'components';
import TourEditContext from '../TourEditContext';

const TourHeaderDropdown: React.FC = () => {
  const { cancelCurrentTour } = useContext(TourEditContext);
  const wrapperRef = useRef();

  return (
    <div ref={wrapperRef}>
      <Dropdown
        trigger={['click']}
        getPopupContainer={() => wrapperRef.current}
        dropdownRender={() => (
          <StyledMenu>
            <StyledMenuItem
              key={'cancel'}
              onClick={cancelCurrentTour}
              data-cy="tour-cancel-button"
            >
              Cancel tour
            </StyledMenuItem>
          </StyledMenu>
        )}
      >
        <StyledButton type="text" size="small" data-cy="tour-header-menu">
          <Icon type="more" width={26} offset={[0, 0]} />
        </StyledButton>
      </Dropdown>
    </div>
  );
};

const StyledButton = styled(Button)`
  padding: 0;
  margin-top: 5px;
  height: 28px;
`;

const StyledMenu = styled(Menu)`
  && {
    border-radius: 0px;
    overflow-y: hidden;
    padding: 0;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  &&& {
    border-radius: 0px;
    white-space: nowrap;
  }
`;

export default TourHeaderDropdown;
